export enum DocumentSource {
    aadhaarApp = 'aadhaarApp',
    digilocker = 'digilocker',
    userUploaded = 'userUploaded'
}